import * as React from 'react';
import { Modal } from '@grandvisionhq/common';
import { H2, Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { pushLoginExpressEditUserDetailsClickEventToDataLayer } from '../../../../data-layer.js';
import { useFormSlotWithoutRedux } from '../../../../slots/forms/form-context.js';
import { useBaseSummarySlot } from '../../../../slots/summaries/summary-context.js';
import '../../../../slots/summaries/types.js';
import { seedShippingForm } from '../../../../StepShipping/mappers/seed-shipping-form.js';
import { useLoggedInCheckout } from '../../../context/context.js';
import '@grandvisionhq/lib-utils-w3c';
import { formStatesToValues } from '../../../utils/form-state-to-values.js';
import { isFormDataValid } from '../../../utils/validate-form-data.js';

const ContactDetailsSummary = ({ contactDetails , onSubmit , isOrderDetailsValid , isFailedToFetchUserData =false  })=>{
    const { getLabel  } = useIntl();
    const { shippingFormFields , formFieldsMap  } = useCheckoutSettings();
    const { isUserLoggedIn  } = useLoggedInCheckout();
    const filledFormData = (shippingFormFields === null || shippingFormFields === void 0 ? void 0 : shippingFormFields.contactDetails) && contactDetails && seedShippingForm(shippingFormFields === null || shippingFormFields === void 0 ? void 0 : shippingFormFields.contactDetails, contactDetails);
    const [contactDetailsState, setContactDetailsState] = React.useState();
    const labels = {
        title: getLabel('checkout.contact.title'),
        save: getLabel('common.actions.save')
    };
    const { Slots  } = useBaseSummarySlot();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const handleSubmit = React.useCallback((contactDetailsFormState)=>{
        if (contactDetailsFormState === null || contactDetailsFormState === void 0 ? void 0 : contactDetailsFormState.formValid) {
            const updatedContactDetails = contactDetailsState && formStatesToValues(contactDetailsFormState.formState);
            updatedContactDetails && (onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
                contactDetails: updatedContactDetails
            }));
            setIsModalOpen(false);
        }
    }, [
        contactDetailsState,
        onSubmit
    ]);
    const isContactDetailsFormComplete = React.useMemo(()=>{
        var ref;
        if ((formFieldsMap === null || formFieldsMap === void 0 ? void 0 : (ref = formFieldsMap.contactDetails) === null || ref === void 0 ? void 0 : ref.length) && !contactDetails) {
            return false;
        } else {
            var ref1;
            return (formFieldsMap === null || formFieldsMap === void 0 ? void 0 : formFieldsMap.contactDetails) ? (ref1 = isFormDataValid(formFieldsMap === null || formFieldsMap === void 0 ? void 0 : formFieldsMap.contactDetails, contactDetails)) !== null && ref1 !== void 0 ? ref1 : false : false;
        }
    }, [
        contactDetails,
        formFieldsMap === null || formFieldsMap === void 0 ? void 0 : formFieldsMap.contactDetails
    ]);
    const onEditHandler = React.useCallback(()=>{
        pushLoginExpressEditUserDetailsClickEventToDataLayer({
            editType: isContactDetailsFormComplete ? 'edit_contact_details' : 'add_contact_details_alert',
            isLoggedIn: isUserLoggedIn
        });
        setIsModalOpen(true);
    }, [
        isContactDetailsFormComplete,
        isUserLoggedIn
    ]);
    const { contactDetails: contactDetailsForm  } = useFormSlotWithoutRedux({
        formInitialData: (filledFormData === null || filledFormData === void 0 ? void 0 : filledFormData.formData) ? {
            contactDetails: filledFormData === null || filledFormData === void 0 ? void 0 : filledFormData.formData
        } : {},
        onChange: setContactDetailsState,
        disableFields: !isFailedToFetchUserData && contactDetails && (!(contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.email) || (contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.email) !== '') ? [
            'email'
        ] : [],
        onSubmit: handleSubmit,
        onCancel: ()=>setIsModalOpen(false)
        ,
        className: 'login-express-checkout__form-modal__form login-express-checkout__form-modal__form--with-custom-height'
    });
    if (!Slots.contactDetails) return null;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isModalOpen,
        onModalClose: ()=>setIsModalOpen(false)
        ,
        showIcon: true,
        className: "login-express-checkout__form-modal"
    }, /*#__PURE__*/ React.createElement(H2, {
        variant: "body-head"
    }, labels.title), /*#__PURE__*/ React.createElement(React.Fragment, null, contactDetailsForm)), /*#__PURE__*/ React.createElement(Slots.contactDetails, {
        actions: {
            onEdit: onEditHandler
        },
        values: contactDetails,
        errorNotification: !isContactDetailsFormComplete ? /*#__PURE__*/ React.createElement(Alert, {
            role: isOrderDetailsValid ? 'status' : 'alert',
            className: "alert-m-default ",
            variant: isOrderDetailsValid ? 'info' : 'error',
            title: getLabel('checkout.contact.incomplete.title')
        }, getLabel('checkout.information.incomplete.message')) : null
    }));
};

export { ContactDetailsSummary };
//# sourceMappingURL=ContactDetailsSummary.js.map
